import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import HolidayService from "services/HolidayService";


let initialState = { list: [] };

export const getHolidays = createAsyncThunk(
  "holiday/getHolidays",
  async (body) => {
    const response = await HolidayService.getHolidays(body);
    return response?.results;
  }
);

export const addHolidays = createAsyncThunk(
  "holiday/addHolidays",
  async (body) => {
    const response = await HolidayService.addHolidays(body);
    return response?.results;
  }
);



const holidaySlice = createSlice({
  name: "holiday",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getHolidays, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(addHolidays, builder);
  },
});

export default holidaySlice.reducer;

